import { Component, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { SurveyCreatorAccessorComponent } from '@unity/forms/composed/survey-creator-accessor/survey-creator-accessor.component';
import { DialogSharedComponent } from '@unity/shared/presentation/dialog-shared/dialog-shared.component';

@Component({
  selector: 'unity-dialog-survey-creator-shared',
  imports: [KENDO_BUTTON, ReactiveFormsModule, DialogSharedComponent, SurveyCreatorAccessorComponent],
  templateUrl: './dialog-survey-creator-shared.component.html',
  styleUrl: './dialog-survey-creator-shared.component.scss',
})
export class DialogSurveyCreatorSharedComponent {
  public readonly $control = input.required<FormControl>({ alias: 'control' });

  public readonly closeEvent = output<void>();

  protected onClose() {
    this.closeEvent.emit();
  }
}
